var _defs, _g, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1400,
    height: 900,
    viewBox: "0 0 1400 900",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1976",
    "data-name": "Rectangle 1976",
    width: 1400,
    height: 900,
    fill: "#7784a1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    y2: 0.575,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f1f5f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f1f5f8",
    stopOpacity: 0
  })))), /*#__PURE__*/React.createElement("g", {
    id: "BG",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_373",
    "data-name": "Group 373",
    transform: "translate(-6.979 77.163)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_371",
    "data-name": "Group 371",
    transform: "translate(-0.006 539.948)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_730",
    "data-name": "Path 730",
    d: "M0,903.348v6.368H1414.37v-6.368Z",
    transform: "translate(0 -635.649)",
    fill: "#d4d4e3",
    opacity: 0.99,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_731",
    "data-name": "Path 731",
    d: "M0,781.948v4.241H1414.37v-4.241Z",
    transform: "translate(0 -603.678)",
    fill: "#d4d4e3",
    opacity: 0.99,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_732",
    "data-name": "Path 732",
    d: "M0,701.038v2.815H1414.37v-2.815Z",
    transform: "translate(0 -582.371)",
    fill: "#d4d4e3",
    opacity: 0.99,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_733",
    "data-name": "Path 733",
    d: "M0,647.068v1.885H1414.37v-1.885Z",
    transform: "translate(0 -568.158)",
    fill: "#d4d4e3",
    opacity: 0.99,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_734",
    "data-name": "Path 734",
    d: "M0,611.1v1.255H1414.37V611.1Z",
    transform: "translate(0 -558.685)",
    fill: "#d4d4e3",
    opacity: 0.99,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_735",
    "data-name": "Path 735",
    d: "M0,587.118v.841H1414.37v-.841Z",
    transform: "translate(0 -552.37)",
    fill: "#d4d4e3",
    opacity: 0.99,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_736",
    "data-name": "Path 736",
    d: "M0,571.138v.555H1414.37v-.555Z",
    transform: "translate(0 -548.162)",
    fill: "#d4d4e3",
    opacity: 0.99,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_737",
    "data-name": "Path 737",
    d: "M0,560.478v.374H1414.37v-.374Z",
    transform: "translate(0 -545.355)",
    fill: "#d4d4e3",
    opacity: 0.99,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_738",
    "data-name": "Path 738",
    d: "M0,553.368v.247H1414.37v-.247Z",
    transform: "translate(0 -543.482)",
    fill: "#d4d4e3",
    opacity: 0.99,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_739",
    "data-name": "Path 739",
    d: "M0,548.638v.164H1414.37v-.164Z",
    transform: "translate(0 -542.237)",
    fill: "#d4d4e3",
    opacity: 0.99,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_740",
    "data-name": "Path 740",
    d: "M0,545.478v.1H1414.37v-.1Z",
    transform: "translate(0 -541.404)",
    fill: "#d4d4e3",
    opacity: 0.99,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_741",
    "data-name": "Path 741",
    d: "M0,543.368v.075H1414.37v-.074Z",
    transform: "translate(0 -540.849)",
    fill: "#d4d4e3",
    opacity: 0.99,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_742",
    "data-name": "Path 742",
    d: "M0,541.018v.069H1414.37v-.069Z",
    transform: "translate(0 -540.23)",
    fill: "#d4d4e3",
    opacity: 0.99,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_743",
    "data-name": "Path 743",
    d: "M0,540.388v.069H1414.37v-.069Z",
    transform: "translate(0 -540.064)",
    fill: "#d4d4e3",
    opacity: 0.99,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_744",
    "data-name": "Path 744",
    d: "M0,539.948v.069H1414.37v-.069Z",
    transform: "translate(0 -539.948)",
    fill: "#d4d4e3",
    opacity: 0.99,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_745",
    "data-name": "Path 745",
    d: "M0,541.948v.069H1414.37v-.069Z",
    transform: "translate(0 -540.475)",
    fill: "#d4d4e3",
    opacity: 0.99,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_372",
    "data-name": "Group 372",
    transform: "translate(-0.021 539.955)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_746",
    "data-name": "Path 746",
    d: "M-.021,937.792Q353.583,738.9,707.179,540,362.78,738.9,18.388,937.792H-.021Z",
    transform: "translate(0.021 -539.969)",
    fill: "#d4d4e3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_747",
    "data-name": "Path 747",
    d: "M0,814.038v-6.362Q353.592,673.841,707.185,540.014h0Q353.592,677.02,0,814.033Z",
    transform: "translate(0.015 -539.973)",
    fill: "#d4d4e3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_748",
    "data-name": "Path 748",
    d: "M0,658.59q353.592-59.313,707.185-118.63Q353.592,600.682,0,661.4",
    transform: "translate(0.015 -539.959)",
    fill: "#d4d4e3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_749",
    "data-name": "Path 749",
    d: "M0,620.729v-1.885H0l707.185-78.873h0L0,620.73Z",
    transform: "translate(0.015 -539.961)",
    fill: "#d4d4e3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_750",
    "data-name": "Path 750",
    d: "M0,592.375,707.185,540,0,593.63",
    transform: "translate(0.015 -539.969)",
    fill: "#d4d4e3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_751",
    "data-name": "Path 751",
    d: "M0,575.591v-.841H0l707.185-34.709h0L0,575.592Z",
    transform: "translate(0.015 -539.98)",
    fill: "#d4d4e3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_752",
    "data-name": "Path 752",
    d: "M0,563.5v-.555l707.185-22.937h0L0,563.5Z",
    transform: "translate(0.015 -539.971)",
    fill: "#d4d4e3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_753",
    "data-name": "Path 753",
    d: "M0,722.466v-4.242H0L707.185,539.992h0L0,722.468Z",
    transform: "translate(0.015 -539.967)",
    fill: "#d4d4e3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_754",
    "data-name": "Path 754",
    d: "M0,555.474V555.1l707.185-15.084h0L0,555.473Z",
    transform: "translate(0.015 -539.973)",
    fill: "#d4d4e3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_755",
    "data-name": "Path 755",
    d: "M0,549.879v.247q353.592-5.035,707.185-10.1h0L0,549.879Z",
    transform: "translate(0.015 -539.977)",
    fill: "#d4d4e3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_756",
    "data-name": "Path 756",
    d: "M0,546.325v.164l707.185-6.527h0L0,546.325Z",
    transform: "translate(0.015 -539.959)",
    fill: "#d4d4e3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_757",
    "data-name": "Path 757",
    d: "M0,544.057l707.185-4.037L0,544.161",
    transform: "translate(0.015 -539.974)",
    fill: "#d4d4e3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_758",
    "data-name": "Path 758",
    d: "M0,542.585v-.075l707.185-2.483h0L0,542.585Z",
    transform: "translate(0.015 -539.976)",
    fill: "#d4d4e3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_759",
    "data-name": "Path 759",
    d: "M-.006,541.556l707.185-1.523L-.006,541.556Z",
    transform: "translate(0.017 -539.978)",
    fill: "#d4d4e3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_760",
    "data-name": "Path 760",
    d: "M378.879,937.792Q592.924,738.9,806.962,540h0Q602.121,738.9,397.288,937.792H378.879Z",
    transform: "translate(-99.761 -539.969)",
    fill: "#d4d4e3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_761",
    "data-name": "Path 761",
    d: "M757.78,937.792Q832.262,738.9,906.746,540h0Q841.469,738.9,776.2,937.792H757.78Z",
    transform: "translate(-199.545 -539.969)",
    fill: "#d4d4e3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_762",
    "data-name": "Path 762",
    d: "M1667.18,937.792Q1313.576,738.9,959.98,540h0q344.4,198.9,688.791,397.792h18.409Z",
    transform: "translate(-252.794 -539.969)",
    fill: "#d4d4e3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_763",
    "data-name": "Path 763",
    d: "M1388.063,937.792Q1174.018,738.9,959.98,540h0q204.841,198.9,409.674,397.792h18.409Z",
    transform: "translate(-252.794 -539.969)",
    fill: "#d4d4e3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_764",
    "data-name": "Path 764",
    d: "M1108.946,937.792Q1034.464,738.9,959.98,540h0q65.277,198.9,130.549,397.792h18.416Z",
    transform: "translate(-252.794 -539.969)",
    fill: "#d4d4e3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_765",
    "data-name": "Path 765",
    d: "M1667.185,814.038v-6.362h0Q1313.593,673.841,960,540.014h0q353.592,137.006,707.185,274.019Z",
    transform: "translate(-252.8 -539.973)",
    fill: "#d4d4e3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_766",
    "data-name": "Path 766",
    d: "M1667.185,658.59Q1313.593,599.277,960,539.96q353.592,60.722,707.185,121.444",
    transform: "translate(-252.8 -539.959)",
    fill: "#d4d4e3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_767",
    "data-name": "Path 767",
    d: "M1667.182,620.729v-1.885h0L959.99,539.971h0l707.192,80.759Z",
    transform: "translate(-252.797 -539.961)",
    fill: "#d4d4e3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_768",
    "data-name": "Path 768",
    d: "M1667.182,592.375,959.99,540l707.192,53.632",
    transform: "translate(-252.797 -539.969)",
    fill: "#d4d4e3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_769",
    "data-name": "Path 769",
    d: "M1667.182,575.591v-.841L959.99,540.042h0l707.192,35.55Z",
    transform: "translate(-252.797 -539.98)",
    fill: "#d4d4e3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_770",
    "data-name": "Path 770",
    d: "M1667.182,563.5v-.555h0L959.99,540.009h0L1667.182,563.5Z",
    transform: "translate(-252.797 -539.971)",
    fill: "#d4d4e3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_771",
    "data-name": "Path 771",
    d: "M1667.182,722.467v-4.241Q1313.59,629.109,959.99,539.993h0q353.592,91.237,707.192,182.476Z",
    transform: "translate(-252.797 -539.967)",
    fill: "#d4d4e3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_772",
    "data-name": "Path 772",
    d: "M1667.182,555.474V555.1L959.99,540.015h0l707.192,15.458Z",
    transform: "translate(-252.797 -539.973)",
    fill: "#d4d4e3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_773",
    "data-name": "Path 773",
    d: "M1667.185,549.879v.247q-353.592-5.035-707.185-10.1h0l707.185,9.85Z",
    transform: "translate(-252.8 -539.977)",
    fill: "#d4d4e3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_774",
    "data-name": "Path 774",
    d: "M1667.182,546.325v.164h0L959.99,539.963h0l707.192,6.362Z",
    transform: "translate(-252.797 -539.959)",
    fill: "#d4d4e3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_775",
    "data-name": "Path 775",
    d: "M1667.182,544.057,959.99,540.02l707.192,4.141",
    transform: "translate(-252.797 -539.974)",
    fill: "#d4d4e3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_776",
    "data-name": "Path 776",
    d: "M1667.182,542.585v-.075h0L959.99,540.027h0l707.192,2.558Z",
    transform: "translate(-252.797 -539.976)",
    fill: "#d4d4e3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_777",
    "data-name": "Path 777",
    d: "M1667.185,541.556,960,540.033Z",
    transform: "translate(-252.8 -539.978)",
    fill: "#d4d4e3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_778",
    "data-name": "Path 778",
    d: "M0,541.462v-.068l707.185-1.437h0L0,541.462Z",
    transform: "translate(0.015 -539.958)",
    fill: "#d4d4e3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_779",
    "data-name": "Path 779",
    d: "M1667.185,541.462v-.068L960,539.958h0Z",
    transform: "translate(-252.8 -539.958)",
    fill: "#d4d4e3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_780",
    "data-name": "Path 780",
    d: "M0,540.808l707.185-.815Z",
    transform: "translate(0.015 -539.967)",
    fill: "#d4d4e3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_781",
    "data-name": "Path 781",
    d: "M707.185,540.808,0,539.993Z",
    transform: "translate(0.015 -539.967)",
    fill: "#d4d4e3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_782",
    "data-name": "Path 782",
    d: "M0,540.81,707.185,540Z",
    transform: "translate(0.015 -539.968)",
    fill: "#d4d4e3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_783",
    "data-name": "Path 783",
    d: "M1667.185,540.81,960,540Z",
    transform: "translate(-252.8 -539.968)",
    fill: "#d4d4e3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_784",
    "data-name": "Path 784",
    d: "M0,540.373V540.3l707.185-.286h0L0,540.373Z",
    transform: "translate(0.015 -539.974)",
    fill: "#d4d4e3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_785",
    "data-name": "Path 785",
    d: "M1667.185,540.373V540.3L960,540.018h0l707.185.355Z",
    transform: "translate(-252.8 -539.974)",
    fill: "#d4d4e3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_786",
    "data-name": "Path 786",
    d: "M0,540.808v-.069H0l707.185-.746h0L0,540.808Z",
    transform: "translate(0.015 -539.967)",
    fill: "#d4d4e3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_787",
    "data-name": "Path 787",
    d: "M1667.185,540.808v-.069h0L960,539.993h0l707.185.815Z",
    transform: "translate(-252.8 -539.967)",
    fill: "#d4d4e3",
    fillRule: "evenodd"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1940",
    "data-name": "Rectangle 1940",
    width: 1400,
    height: 900,
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginBg);
export default __webpack_public_path__ + "static/media/login_bg.82fce50a360a6e020cb46a1fc203fd51.svg";
export { ForwardRef as ReactComponent };